(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5672],{

/***/ 89811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_HeroCategory; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/@types/grid-preset.ts
var grid_preset = __webpack_require__(31538);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-slider/dist/es/index.js + 19 modules
var es = __webpack_require__(7924);
// EXTERNAL MODULE: ./src/components/UI/BannerImage/index.tsx
var BannerImage = __webpack_require__(4017);
// EXTERNAL MODULE: ./src/components/UI/Icons/index.tsx + 17 modules
var Icons = __webpack_require__(54678);
// EXTERNAL MODULE: ./src/components/UI/InlineCta/index.tsx + 1 modules
var InlineCta = __webpack_require__(85499);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/hooks/useINPTrick/index.ts
var useINPTrick = __webpack_require__(20462);
// EXTERNAL MODULE: ./src/components/Abstracts/LayoutSwitcher/styles.module.scss
var styles_module = __webpack_require__(94701);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Abstracts/LayoutSwitcher/index.tsx





var cx = bind_default().bind((styles_module_default()));
function LayoutSwitcherItem(param) {
    var className = param.className, activeClassName = param.activeClassName, index = param.index, isActive = param.isActive, name = param.name, onClick = param.onClick, children = param.children;
    var ref = (0,useINPTrick/* useINPTrick */.z)(), hasInteracted = ref.hasInteracted, onInteract = ref.onInteract;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: cx(className, (styles_module_default()).switcher, isActive || hasInteracted ? activeClassName : null, {
            isActive: isActive
        }),
        "aria-label": "layout-switcher",
        onClick: function(e) {
            !isActive ? onInteract(function() {
                return onClick(name);
            }) : null;
        },
        children: children
    });
}
function LayoutSwitcher(param) {
    var className = param.className, steps = param.steps, currentStep = param.currentStep, onClickCallback = param.onClickCallback;
    var onClickSwitcher = (0,react.useCallback)(function(step) {
        onClickCallback && onClickCallback(step);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: cx((styles_module_default()).LayoutSwitcher, className),
        children: steps === null || steps === void 0 ? void 0 : steps.map(function(step, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(LayoutSwitcherItem, {
                className: step === null || step === void 0 ? void 0 : step.className,
                activeClassName: step === null || step === void 0 ? void 0 : step.activeClassName,
                isActive: currentStep === (step === null || step === void 0 ? void 0 : step.name),
                index: index,
                name: step === null || step === void 0 ? void 0 : step.name,
                onClick: onClickSwitcher,
                children: step === null || step === void 0 ? void 0 : step.icon
            }, "layout_switcher_item_".concat(index));
        })
    });
}
LayoutSwitcher.defaultProps = {};
/* harmony default export */ var Abstracts_LayoutSwitcher = (LayoutSwitcher);

// EXTERNAL MODULE: ./src/components/UI/LayoutSwitcher/styles.module.scss
var LayoutSwitcher_styles_module = __webpack_require__(76231);
var LayoutSwitcher_styles_module_default = /*#__PURE__*/__webpack_require__.n(LayoutSwitcher_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/LayoutSwitcher/index.tsx






var LayoutSwitcher_cx = bind_default().bind((LayoutSwitcher_styles_module_default()));
function LayoutSwitcher_LayoutSwitcher(_param) {
    var className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Abstracts_LayoutSwitcher, (0,_object_spread/* default */.Z)({
        className: LayoutSwitcher_cx((LayoutSwitcher_styles_module_default()).LayoutSwitcher, className)
    }, rest));
}
LayoutSwitcher_LayoutSwitcher.defaultProps = {};
/* harmony default export */ var UI_LayoutSwitcher = (LayoutSwitcher_LayoutSwitcher);

// EXTERNAL MODULE: ./src/components/UI/RichText/index.tsx
var RichText = __webpack_require__(55071);
// EXTERNAL MODULE: ./src/providers/LayoutSwitcherProvider/index.tsx
var LayoutSwitcherProvider = __webpack_require__(70306);
// EXTERNAL MODULE: ./src/providers/PaginationProvider/index.tsx
var PaginationProvider = __webpack_require__(49981);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/hooks/useBreakpoint/index.ts + 4 modules
var useBreakpoint = __webpack_require__(7695);
// EXTERNAL MODULE: ./src/data/dictionary/index.ts + 1 modules
var dictionary = __webpack_require__(9554);
// EXTERNAL MODULE: ./src/components/UI/HeroCategory/styles.module.scss
var HeroCategory_styles_module = __webpack_require__(46659);
var HeroCategory_styles_module_default = /*#__PURE__*/__webpack_require__.n(HeroCategory_styles_module);
// EXTERNAL MODULE: ./src/@types/breakpoints.ts
var breakpoints = __webpack_require__(59646);
;// CONCATENATED MODULE: ./src/components/UI/HeroCategory/index.tsx
























var HeroCategory_cx = bind_default().bind((HeroCategory_styles_module_default()));
function HeroCategory(param) {
    var className = param.className, title = param.title, subNavigation = param.subNavigation, enableBannerHero = param.enableBannerHero, image = param.image, mobileImage = param.mobileImage, categorySubtitle = param.categorySubtitle, leftParagraph = param.leftParagraph, rightParagraph = param.rightParagraph;
    var ref;
    var ref1 = (0,LayoutSwitcherProvider/* useLayoutSwitcherProvider */.dX)(), currentStep = ref1.step, setCurrentStep = ref1.setStep;
    var isMobile = (0,useBreakpoint/* default */.Z)(breakpoints/* GLOBAL_BREAKPOINTS.LG */.L.LG);
    var customSliderRef = (0,react.useRef)();
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    var titleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Title40SangBleu */.C.Title40SangBleu
    });
    var setCurrentPage = (0,PaginationProvider/* usePagination */.h0)().setCurrentPage;
    var router = (0,next_router.useRouter)();
    var earringRegex = new RegExp(/boucles-doreilles|earrings/, "g");
    var shouldRenderSubtitle = earringRegex.test(router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.uid);
    var subtitleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12SangBleu */.C.Text12SangBleu,
        textStyling: text_styling/* GlobalTextStyling.Italic */.l.Italic,
        color: colors/* GlobalThemeColors.Gray */.b.Gray
    });
    (0,react.useEffect)(function() {
        if (isMobile && currentStep === LayoutSwitcherProvider/* LAYOUT.SMALL */._.SMALL) {
            setCurrentStep(LayoutSwitcherProvider/* LAYOUT.MEDIUM */._.MEDIUM);
        }
    }, [
        isMobile
    ]);
    (0,react.useEffect)(function() {
        // When changing page, reset layout
        return function() {
            setCurrentStep(LayoutSwitcherProvider/* LAYOUT.MEDIUM */._.MEDIUM);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: HeroCategory_cx((HeroCategory_styles_module_default()).HeroCategory, className, {
            withBanner: enableBannerHero
        }),
        ref: customSliderRef,
        children: [
            enableBannerHero && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: HeroCategory_cx((HeroCategory_styles_module_default()).bannerHero),
                children: [
                    (image || mobileImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerImage/* default */.Z, {
                        className: HeroCategory_cx((HeroCategory_styles_module_default()).bannerImage),
                        image: image,
                        mobileImage: mobileImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: HeroCategory_cx((HeroCategory_styles_module_default()).titleRow, gridStyle),
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: HeroCategory_cx((HeroCategory_styles_module_default()).title, titleStyle),
                                children: title
                            }),
                            (leftParagraph || rightParagraph) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: HeroCategory_cx((HeroCategory_styles_module_default()).paragraphs),
                                children: [
                                    leftParagraph && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: HeroCategory_cx((HeroCategory_styles_module_default()).paragraph, (HeroCategory_styles_module_default()).leftParagraph),
                                        children: leftParagraph
                                    }),
                                    rightParagraph && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: HeroCategory_cx((HeroCategory_styles_module_default()).paragraph, (HeroCategory_styles_module_default()).rightParagraph),
                                        children: rightParagraph
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: HeroCategory_cx((HeroCategory_styles_module_default()).wrapper, gridStyle),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HeroCategory_styles_module_default()).left,
                        children: ((subNavigation === null || subNavigation === void 0 ? void 0 : subNavigation.length) > 0 || !enableBannerHero) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (HeroCategory_styles_module_default()).title,
                                    children: title && (enableBannerHero ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: HeroCategory_cx((HeroCategory_styles_module_default()).title, titleStyle),
                                        children: dictionary/* LABEL.ALL */.GP.ALL
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: HeroCategory_cx((HeroCategory_styles_module_default()).title, titleStyle),
                                        children: title
                                    }))
                                }),
                                (subNavigation === null || subNavigation === void 0 ? void 0 : subNavigation.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: HeroCategory_cx((HeroCategory_styles_module_default()).subcategories, (HeroCategory_styles_module_default()) === null || (HeroCategory_styles_module_default()) === void 0 ? void 0 : (HeroCategory_styles_module_default()).hideOnSmallScreen),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (HeroCategory_styles_module_default()).content,
                                        children: subNavigation === null || subNavigation === void 0 ? void 0 : subNavigation.map(function(subcategory, index) {
                                            return /*#__PURE__*/ (0,react.createElement)(InlineCta/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, subcategory), {
                                                textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
                                                textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
                                                key: "subcategory_item_".concat(index),
                                                lineProps: {
                                                    initialLineState: "none"
                                                },
                                                className: (HeroCategory_styles_module_default()).subcategoryLink
                                            }));
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (HeroCategory_styles_module_default()).right,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_LayoutSwitcher, {
                                className: HeroCategory_cx((HeroCategory_styles_module_default()).layoutSwitcher, (HeroCategory_styles_module_default()).hideOnSmallScreen),
                                currentStep: currentStep,
                                onClickCallback: function(step) {
                                    setCurrentStep(step);
                                    // Reset current page to 1 on layout update
                                    setCurrentPage(1);
                                },
                                steps: [
                                    {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* BigLayoutIcon */.wr, {
                                            className: (HeroCategory_styles_module_default()).icon
                                        }),
                                        className: (HeroCategory_styles_module_default()).layoutSwitcherItem,
                                        activeClassName: (HeroCategory_styles_module_default()).isActive,
                                        name: LayoutSwitcherProvider/* LAYOUT.BIG */._.BIG
                                    },
                                    {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* MediumLayoutIcon */.Pp, {
                                            className: (HeroCategory_styles_module_default()).icon
                                        }),
                                        className: (HeroCategory_styles_module_default()).layoutSwitcherItem,
                                        activeClassName: (HeroCategory_styles_module_default()).isActive,
                                        name: LayoutSwitcherProvider/* LAYOUT.MEDIUM */._.MEDIUM
                                    },
                                    {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SmallLayoutIcon */.Sc, {
                                            className: (HeroCategory_styles_module_default()).icon
                                        }),
                                        className: (HeroCategory_styles_module_default()).layoutSwitcherItem,
                                        activeClassName: (HeroCategory_styles_module_default()).isActive,
                                        name: LayoutSwitcherProvider/* LAYOUT.SMALL */._.SMALL
                                    }, 
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_LayoutSwitcher, {
                                className: HeroCategory_cx((HeroCategory_styles_module_default()).layoutSwitcher, (HeroCategory_styles_module_default()).hideOnLargeScreen, (HeroCategory_styles_module_default()).smallScreen),
                                currentStep: currentStep,
                                onClickCallback: function(step) {
                                    setCurrentStep(step);
                                    // Reset current page to 1 on layout update
                                    setCurrentPage(1);
                                },
                                steps: [
                                    {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* MonoLayoutIcon */.r9, {
                                            className: (HeroCategory_styles_module_default()).icon
                                        }),
                                        className: (HeroCategory_styles_module_default()).layoutSwitcherItem,
                                        activeClassName: (HeroCategory_styles_module_default()).isActive,
                                        name: LayoutSwitcherProvider/* LAYOUT.BIG */._.BIG
                                    },
                                    {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* BigLayoutIcon */.wr, {
                                            className: (HeroCategory_styles_module_default()).icon
                                        }),
                                        className: (HeroCategory_styles_module_default()).layoutSwitcherItem,
                                        activeClassName: (HeroCategory_styles_module_default()).isActive,
                                        name: LayoutSwitcherProvider/* LAYOUT.MEDIUM */._.MEDIUM
                                    }, 
                                ]
                            })
                        ]
                    }),
                    shouldRenderSubtitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                        render: categorySubtitle,
                        className: HeroCategory_cx(subtitleStyle, (HeroCategory_styles_module_default()).categorySubtitle)
                    }) : null,
                    (subNavigation === null || subNavigation === void 0 ? void 0 : subNavigation.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.ZP, {
                        className: HeroCategory_cx((HeroCategory_styles_module_default()).slider, (HeroCategory_styles_module_default()).mobileSubNavigation, (HeroCategory_styles_module_default()) === null || (HeroCategory_styles_module_default()) === void 0 ? void 0 : (HeroCategory_styles_module_default()).hideOnLargeScreen),
                        customSliderRef: customSliderRef,
                        snap: true,
                        children: subNavigation === null || subNavigation === void 0 ? void 0 : subNavigation.map(function(subcategory, index) {
                            return /*#__PURE__*/ (0,react.createElement)(InlineCta/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, subcategory), {
                                key: "subcategory_item_".concat(index),
                                lineProps: {
                                    initialLineState: "none"
                                },
                                className: (HeroCategory_styles_module_default()).subcategoryLink
                            }));
                        })
                    })
                ]
            })
        ]
    });
}
HeroCategory.defaultProps = {};
/* harmony default export */ var UI_HeroCategory = (HeroCategory);


/***/ }),

/***/ 29538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_polyglot__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14408);
/* harmony import */ var _types_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37444);
/* harmony import */ var _types_text_preset__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95348);
/* harmony import */ var _components_UI_InlineCta__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85499);
/* harmony import */ var _data_dictionary__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9554);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10052);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);









var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()));
function ReadMoreText(param) {
    var className = param.className, text = param.text, charsLimit = param.charsLimit, hasReadLess = param.hasReadLess;
    var t = (0,react_polyglot__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var isTruncated = text && text.length > charsLimit;
    var truncatedText = isTruncated ? "".concat(text.slice(0, charsLimit), "...") : text;
    var shouldShowButton = hasReadLess ? isTruncated : isTruncated && !isOpen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ReadMoreText), className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
            className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().truncatedText)),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().textItem),
                    children: isOpen ? text : truncatedText
                }),
                shouldShowButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_InlineCta__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_5__/* .GlobalTextPreset.Cta12Grotesk */ .C.Cta12Grotesk,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().descriptionCta),
                    theme: _types_colors__WEBPACK_IMPORTED_MODULE_4__/* .GlobalThemeColors.Black */ .b.Black,
                    onClick: function() {
                        return setIsOpen(!isOpen);
                    },
                    children: t(isOpen ? _data_dictionary__WEBPACK_IMPORTED_MODULE_7__/* .CTA.READ_LESS */ .MV.READ_LESS : _data_dictionary__WEBPACK_IMPORTED_MODULE_7__/* .CTA.READ_MORE */ .MV.READ_MORE)
                })
            ]
        })
    });
}
ReadMoreText.defaultProps = {
    hasReadLess: true
};
/* harmony default export */ __webpack_exports__["Z"] = (ReadMoreText);


/***/ }),

/***/ 54725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ category_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/lib/storyblok-types.ts
var storyblok_types = __webpack_require__(18685);
// EXTERNAL MODULE: ./src/components/Slices/BigTitle/index.tsx
var BigTitle = __webpack_require__(55734);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./src/@types/grid-preset.ts
var grid_preset = __webpack_require__(31538);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/components/UI/ReadMoreText/index.tsx
var ReadMoreText = __webpack_require__(29538);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/components/Slices/EditorialTextReadMore/styles.module.scss
var styles_module = __webpack_require__(99844);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Slices/EditorialTextReadMore/index.tsx







var cx = bind_default().bind((styles_module_default()));
function EditorialTextReadMore(param) {
    var className = param.className, text = param.text, limit = param.limit;
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    var textStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text14GroteskRegular */.C.Text14GroteskRegular
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: cx((styles_module_default()).EditorialTextReadMore, className, gridStyle),
        children: text && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMoreText/* default */.Z, {
            className: cx((styles_module_default()).text, textStyle),
            charsLimit: limit,
            text: text
        })
    });
}
EditorialTextReadMore.defaultProps = {
    limit: 200
};
/* harmony default export */ var Slices_EditorialTextReadMore = (EditorialTextReadMore);

// EXTERNAL MODULE: ./src/components/Slices/EditorialTitleParagraphCta/index.tsx
var EditorialTitleParagraphCta = __webpack_require__(76791);
// EXTERNAL MODULE: ./src/components/Slices/HeroSlider/index.tsx + 1 modules
var HeroSlider = __webpack_require__(88860);
// EXTERNAL MODULE: ./src/components/Slices/ProductsGrid/index.tsx
var ProductsGrid = __webpack_require__(16197);
// EXTERNAL MODULE: ./src/components/Slices/ProductsPinsPush/index.tsx
var ProductsPinsPush = __webpack_require__(27733);
// EXTERNAL MODULE: ./src/components/Slices/PushCategories/index.tsx + 1 modules
var PushCategories = __webpack_require__(7817);
// EXTERNAL MODULE: ./src/components/Slices/PushGeneric/index.tsx + 1 modules
var PushGeneric = __webpack_require__(70544);
// EXTERNAL MODULE: ./src/components/Slices/PushSocial/index.tsx + 1 modules
var PushSocial = __webpack_require__(75562);
// EXTERNAL MODULE: ./src/components/Slices/PushStores/index.tsx + 1 modules
var PushStores = __webpack_require__(97014);
// EXTERNAL MODULE: ./src/components/Slices/PushTypeListing/index.tsx + 1 modules
var PushTypeListing = __webpack_require__(37923);
// EXTERNAL MODULE: ./src/components/Slices/ThreeColumnsImageWysiwyg/index.tsx
var ThreeColumnsImageWysiwyg = __webpack_require__(54165);
// EXTERNAL MODULE: ./src/components/Slices/TwoColumnsImageTitleWysiwygs/index.tsx
var TwoColumnsImageTitleWysiwygs = __webpack_require__(62549);
;// CONCATENATED MODULE: ./src/imports/category_page.ts















var _obj;
/* harmony default export */ var category_page = (_obj = {}, (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.HERO_SLIDER */.zj.HERO_SLIDER, HeroSlider/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.PUSH_CATEGORIES */.zj.PUSH_CATEGORIES, PushCategories/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.PUSH_GENERIC */.zj.PUSH_GENERIC, PushGeneric/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.PUSH_STORES */.zj.PUSH_STORES, PushStores/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.PUSH_SOCIAL */.zj.PUSH_SOCIAL, PushSocial/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.PRODUCTS_GRID */.zj.PRODUCTS_GRID, ProductsGrid/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.PUSH_DESIGNERS */.zj.PUSH_DESIGNERS, PushTypeListing/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.BIG_TITLE */.zj.BIG_TITLE, BigTitle/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.PRODUCTS_PINS_PUSH */.zj.PRODUCTS_PINS_PUSH, ProductsPinsPush/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.EDITORIAL_TITLE_PARAGRAPH_CTA */.zj.EDITORIAL_TITLE_PARAGRAPH_CTA, EditorialTitleParagraphCta/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.EDITORIAL_TEXT_READ_MORE */.zj.EDITORIAL_TEXT_READ_MORE, Slices_EditorialTextReadMore), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.TWO_COLUMNS_IMAGE_TITLE_WYSIWYGS */.zj.TWO_COLUMNS_IMAGE_TITLE_WYSIWYGS, TwoColumnsImageTitleWysiwygs/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.THREE_COLUMNS_IMAGE_WYSIWYG */.zj.THREE_COLUMNS_IMAGE_WYSIWYG, ThreeColumnsImageWysiwyg/* default */.Z), _obj);


/***/ }),

/***/ 94701:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 99844:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"EditorialTextReadMore":"styles_EditorialTextReadMore__jCOJp","text":"styles_text__V0G3w"};

/***/ }),

/***/ 46659:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"HeroCategory":"styles_HeroCategory__RNRJg","hideOnSmallScreen":"styles_hideOnSmallScreen__54_9a","hideOnLargeScreen":"styles_hideOnLargeScreen__N1HC_","wrapper":"styles_wrapper__ok6YP","bannerHero":"styles_bannerHero__hrfum","titleRow":"styles_titleRow__YPgoU","title":"styles_title__YlqPm","paragraphs":"styles_paragraphs__X1tCj","leftParagraph":"styles_leftParagraph__9XbXJ","rightParagraph":"styles_rightParagraph__L2bo5","left":"styles_left__iEQHa","viewMore":"styles_viewMore__uzFY4","subcategories":"styles_subcategories__Rx_JO","subcategoryLink":"styles_subcategoryLink__8rnyr","content":"styles_content__CTPty","right":"styles_right__YBX3_","mobileSubNavigation":"styles_mobileSubNavigation__oxIx7","layoutSwitcher":"styles_layoutSwitcher__wwz0g","layoutSwitcherItem":"styles_layoutSwitcherItem__A_dhX","isActive":"styles_isActive__OxxnM","smallScreen":"styles_smallScreen__Y2q0w","withBanner":"styles_withBanner__181QU","categorySubtitle":"styles_categorySubtitle__c14Iu"};

/***/ }),

/***/ 76231:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 10052:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ReadMoreText":"styles_ReadMoreText__4JKeQ","textItem":"styles_textItem__DJgVF"};

/***/ })

}]);